import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";

import { AutocompleteSearch } from "./autocomplete-search.model";

@Injectable({
  providedIn: "root",
})
export class AutocompleteSearchService {
  constructor(private http: HttpClient) {}
  public getAutocompleteSearch(search: string) {
    return this.http.get<AutocompleteSearch>(`/find_v2/_autocomplete?prefix=${search}`);
  }
}
